module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Barry-S2.0574756.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Barry-S2.jpg
// module id = RDhr
// module chunks = 0